import { dateLocaleFor } from '../../i18n/formats';

const fmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' });
const toDate = iso => new Date(`${iso}T12:00:00Z`);
const toIso = d => d.toISOString().slice(0, 10);

export const todayET = (now = new Date()) => fmt.format(now);

export function addDays(iso, n) {
  const d = toDate(iso);
  d.setUTCDate(d.getUTCDate() + n);
  return toIso(d);
}

export function weekDays(iso) {
  const offset = (toDate(iso).getUTCDay() + 6) % 7;
  const monday = addDays(iso, -offset);
  return Array.from({ length: 7 }, (_, i) => addDays(monday, i));
}

export function monthWeeks(iso) {
  const first = `${iso.slice(0, 8)}01`;
  const d = toDate(first);
  d.setUTCMonth(d.getUTCMonth() + 1, 0);
  const last = toIso(d);
  const weeks = [];
  for (let start = weekDays(first)[0]; start <= last; start = addDays(start, 7)) weeks.push(weekDays(start));
  return weeks;
}

export function addMonths(iso, n) {
  const d = toDate(`${iso.slice(0, 8)}01`);
  d.setUTCMonth(d.getUTCMonth() + n);
  return toIso(d);
}

export function formatDay(iso, lang) {
  const f = new Intl.DateTimeFormat(dateLocaleFor(lang), { timeZone: 'UTC', weekday: 'short', day: '2-digit', month: '2-digit' });
  return f.format(toDate(iso));
}

export function formatWeekRange(weekDates, lang) {
  const start = toDate(weekDates[0]);
  const end = toDate(weekDates.at(-1));
  const crossesYear = start.getUTCFullYear() !== end.getUTCFullYear();
  const f = new Intl.DateTimeFormat(dateLocaleFor(lang), { timeZone: 'UTC', month: 'short', day: 'numeric', year: crossesYear ? 'numeric' : undefined });
  return `${f.format(start)} – ${f.format(end)}`;
}

export function formatMonthLabel(iso, lang) {
  const f = new Intl.DateTimeFormat(dateLocaleFor(lang), { timeZone: 'UTC', month: 'long', year: 'numeric' });
  return f.format(toDate(iso));
}

export function formatEasternTime(iso, lang) {
  if (!iso) return '';
  const locale = dateLocaleFor(lang);
  if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
    return new Intl.DateTimeFormat(locale, { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' }).format(toDate(iso));
  }
  const f = new Intl.DateTimeFormat(locale, { timeZone: 'America/New_York', weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  return `${f.format(new Date(iso))} ET`;
}

export function formatEasternClock(iso, lang) {
  if (!iso) return '';
  const locale = dateLocaleFor(lang);
  const f = new Intl.DateTimeFormat(locale, { timeZone: 'America/New_York', hour: 'numeric', minute: '2-digit', hour12: true });
  return `${f.format(new Date(iso))} ET`;
}

export function nextBankDay(iso) {
  let d = addDays(iso, 1);
  while ([0, 6].includes(toDate(d).getUTCDay())) d = addDays(d, 1);
  return d;
}
